import {DescriptionText} from "../../../../design";
import React from "react";
type Props = {
  invoice: Object,
  account: Object
}
const Notes = (props: Props) => {
  const {invoice, account} = props;
  return (
    <>
      <div className="row mt-5 px-3 px-lg-0" hidden={!(invoice && invoice.customerNote)}>
        <div className="col px-0">
          <DescriptionText>Notes</DescriptionText>
          <div style={{
            background: '#f9fafb',
            border: '1px solid #f5f6fa',
            borderRadius: '6px',
            padding: '6px 10px',
            marginTop: '4px',
          }}>
            <DescriptionText fontWeight="400">{invoice && invoice.customerNote}</DescriptionText>
          </div>
        </div>
      </div>
      {/* <div className="row mt-4 px-3 px-lg-0" hidden={!(account && account.name)}>
        <div className="col px-0">
          <DescriptionText borderRadius="3px" fontWeight="400" className="p-2" style={{background:"#eeeeff"}} >{account && account.name}.</DescriptionText>
        </div>
      </div> */}
    </>
  )
};

export default Notes
